import { FormDataType } from "DataTypes/Form";

export const CaseCreationFormArr: FormDataType[] = [
  {
    id: "orderType",
    label: "Order Type",
    placeholder: "Select Order Type",
    boxType: "single-select-drop",
    boxSize: 12,
    validatetype: "dropdown",
    required: true,
    dropArr: [],
    infoText: "If you can’t find what you’re looking for, please select 'Other.' category"
  },
  {
    id: "caseType",
    label: "Case Type",
    placeholder: "Select Case Type",
    boxType: "single-select-drop",
    boxSize: 12,
    validatetype: "dropdown",
    required: true,
    dropArr: [],
    infoText: "If you can’t find what you’re looking for, please select 'Other.' category"
  },
  // {
  //   id: "description",
  //   label: "Description",
  //   placeholder: "Enter Description",
  //   boxType: "input-box",
  //   type: "text",
  //   boxSize: 12,
  //   validatetype: "acceptAll",
  //   required: true,
  //   multiline: true,
  //   multilineRows: 4,
  // },
];
